import { isNull } from 'lodash/fp';
import React, { useEffect, useMemo } from 'react';

import { useAppDispatch, useAppSelector } from '../../../../hooks/react-redux';
import { useFetchStarted } from '../../../../hooks/useFetchStarted';
import { fetchAllDropdownListsStarted } from '../../../admin/dropdown-lists/store';
import { fetchAllNettingEntitiesStarted } from '../../../admin/entity/store';
import { PageLoadingDots } from '../../../shared/loading-dots/PageLoadingDots';
import { getCurrentNettingEngineData, getIsCalculatingResults, getNettingEngineResults, getSurveyQuestionIndex, resetEngineDataState } from '../store';
import styles from './Theoretical.module.scss';
import { TheoreticalSurvey } from './TheoreticalSurvey';
import { NettingEngineResultsWrapper } from '../NettingEngineResultsWrapper';

export const NettingEngineTheoretical: React.FC = () => {
    const dispatch = useAppDispatch();

    useFetchStarted([fetchAllDropdownListsStarted(), fetchAllNettingEntitiesStarted()]);

    const currentNettingEngineData = useAppSelector(getCurrentNettingEngineData);
    const theoreticalResults = useAppSelector(getNettingEngineResults);
    const calculatingResults = useAppSelector(getIsCalculatingResults);
    const surveyQuestionIndex = useAppSelector(getSurveyQuestionIndex);

    const END_OF_SURVEY_INDEX = 10;

    useEffect(() => () => {
        dispatch(resetEngineDataState());
    }, [dispatch]);

    const component = useMemo(() => {
        if (calculatingResults) {
            return <PageLoadingDots />;
        }
        if (!isNull(theoreticalResults)) {
            return <NettingEngineResultsWrapper results={theoreticalResults} />;
        }
        if (isNull(theoreticalResults) && surveyQuestionIndex !== END_OF_SURVEY_INDEX) {
            return <TheoreticalSurvey
                surveyQuestionIndex={surveyQuestionIndex}
                surveyAnswers={currentNettingEngineData}
            />;
        }
    }, [calculatingResults, currentNettingEngineData, theoreticalResults, surveyQuestionIndex]);

    return (
        <div className={styles.theoreticalWrapper}>
            {component}
        </div>
    );
};
